<template>
  <!-- 收款弹窗 -->
  <el-dialog title="收款" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" @close="handleClose">
    <!-- 收款表单 -->
    <el-form :model="formData" :rules="rules" ref="paymentForm" label-width="120px">
      <!-- 客户名称（自动填充，禁用编辑） -->
      <el-form-item label="客户名称" prop="compName">
        <el-input v-model="formData.compName" disabled></el-input>
      </el-form-item>

      <!-- 使用单位（自动填充，禁用编辑） -->
      <el-form-item label="使用单位" prop="usingUnit">
        <el-input v-model="formData.usingUnit" disabled></el-input>
      </el-form-item>

      <!-- 应收款（自动计算，禁用编辑） -->
      <el-form-item label="应收款" prop="receivableAmount">
        <el-input v-model="formData.receivableAmount" disabled>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- 实收款（必填） -->
      <el-form-item label="实收款" prop="actualReceiptAmount">
        <el-input v-model="formData.actualReceiptAmount" placeholder="请输入实收款金额" type="number">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- 实收原因（当实收款与应收款不一致时填写） -->
      <el-form-item label="实收原因" prop="receiptReason">
        <el-input v-model="formData.receiptReason" type="textarea" :rows="2" placeholder="实收款与应收款不一致时请填写原因"></el-input>
      </el-form-item>

      <!-- 收款方式（必填） -->
      <el-form-item label="收款方式" prop="paymentType">
        <el-radio-group v-model="formData.paymentType">
          <el-radio :label="1">正常收款</el-radio>
          <el-radio :label="2">优惠</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 收款时间（默认当天） -->
      <el-form-item label="收款时间" prop="receiptTime">
        <el-date-picker v-model="formData.receiptTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-ddTHH:mm:ss" style="width: 100%;" />
      </el-form-item>

      <!-- 收款登记人（自动填充，禁用编辑） -->
      <el-form-item label="收款登记人" prop="payeeName">
        <el-input v-model="formData.payeeName" disabled></el-input>
      </el-form-item>

      <!-- 收款帐号（必填） -->
      <el-form-item label="收款帐号" prop="receiptMethod">
        <el-select v-model="formData.receiptMethod" placeholder="请选择收款帐号" style="width: 100%;" filterable allow-create>
          <el-option label="晨宇微信" value="晨宇微信"></el-option>
          <el-option label="晨宇民生9888" value="晨宇民生9888"></el-option>
          <el-option label="晨宇招行0901" value="晨宇招行0901"></el-option>
          <el-option label="晨宇现金" value="晨宇现金"></el-option>
          <el-option label="晨宇漳州0192" value="晨宇漳州0192"></el-option>
          <el-option label="晨宇总部" value="晨宇总部"></el-option>
        </el-select>
      </el-form-item>
      <!-- 收款公司（必填） -->
      <el-form-item label="收款公司" prop="receiptCompany">
        <el-select v-model="formData.receiptCompany" placeholder="请选择" style="width: 100%;">
          <el-option label="晨宇安全科技集团有限公司" value="晨宇安全科技集团有限公司"></el-option>
          <el-option label="晨宇安全科技集团有限公司泉州分公司" value="晨宇安全科技集团有限公司泉州分公司"></el-option>
          <el-option label="晨宇安全科技集团有限公司漳州分公司" value="晨宇安全科技集团有限公司漳州分公司"></el-option>
        </el-select>
      </el-form-item>
      <!-- 备注（可选） -->
      <el-form-item label="备注" prop="remark">
        <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>

    <!-- 弹窗底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave" :loading="saveLoading">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 导入保存收款API
import { saveReceivables } from '@/api/contract/contract'

export default {
  name: 'PaymentDialog',
  watch: {
    // 监听实收款变化，触发实收原因字段的验证
    'formData.actualReceiptAmount' () {
      this.$nextTick(() => {
        if (this.$refs.paymentForm) {
          this.$refs.paymentForm.validateField('receiptReason')
        }
      })
    }
  },
  data () {
    return {
      // 弹窗显示状态
      dialogVisible: false,
      // 保存按钮加载状态
      saveLoading: false,
      // 选中的数据列表
      selectedData: [],
      // 表单数据
      formData: {
        compName: '',           // 客户名称
        usingUnit: '',          // 使用单位
        receivableAmount: 0,    // 应收款总额
        actualReceiptAmount: 0, // 实收款金额
        receiptReason: '',      // 实收原因
        receiptTime: '',        // 收款时间
        payeeName: '',          // 收款登记人
        receiptMethod: '',      // 收款帐号
        receiptCompany: '',      // 收款公司
        remark: '',              // 备注
        paymentType: 1           // 收款方式：1=正常收款，2=优惠（默认正常收款）
      },
      // 表单验证规则
      rules: {
        receiptTime: [
          { required: true, message: '请选择收款时间', trigger: 'change' }
        ],
        actualReceiptAmount: [
          { required: true, message: '请输入实收款金额', trigger: 'blur' }
        ],
        receiptMethod: [
          { required: true, message: '请选择收款帐号', trigger: 'change' }
        ],
        receiptCompany: [
          { required: true, message: '请选择收款公司', trigger: 'blur' }
        ],
        paymentType: [
          { required: true, message: '请选择收款方式', trigger: 'change' }
        ],
        receiptReason: [
          {
            validator: (rule, value, callback) => {
              const actualAmount = parseFloat(this.formData.actualReceiptAmount) || 0
              const receivableAmount = parseFloat(this.formData.receivableAmount) || 0
              // 当实收款与应收款不一致时，实收原因必填
              if (actualAmount !== receivableAmount && !value && this.formData.paymentType === 2) {
                callback(new Error('优惠情况下实收款与应收款不一致时，实收原因为必填项'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    /**
     * 打开弹窗
     * @param {Array} selectedRows - 选中的数据行数组
     */
    openDialog (selectedRows) {
      this.selectedData = selectedRows
      this.dialogVisible = true

      // 初始化表单数据
      const firstRow = selectedRows[0]
      // 客户名称和使用单位取第一条数据
      this.formData.compName = firstRow.compName
      this.formData.usingUnit = firstRow.usingUnit

      // 按“分”累加，避免 JS 浮点误差导致金额对不上
      const toCents = (val) => Math.round((parseFloat(val) || 0) * 100)
      const totalReceivableCents = selectedRows.reduce((sum, row) => sum + toCents(row.totalTestAmount), 0)
      const totalPaidCents = selectedRows.reduce((sum, row) => sum + toCents(row.totalPaidAmount), 0)
      const needToPay = ((totalReceivableCents - totalPaidCents) / 100).toFixed(2)

      this.formData.receivableAmount = needToPay

      // 默认实收款等于还需收款金额
      this.formData.actualReceiptAmount = needToPay

      // 设置默认收款时间为当天
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      this.formData.receiptTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`

      // 设置默认收款登记人（从store中获取当前登录用户）
      this.formData.payeeName = this.$store.state.loginUser.userName || ''

      // 清空其他字段
      this.formData.receiptMethod = ''
      this.formData.receiptCompany = ''
      this.formData.remark = ''
      this.formData.receiptReason = ''
      this.formData.paymentType = 1 // 默认正常收款
    },

    /**
     * 保存收款信息
     */
    handleSave () {
      // 表单验证
      this.$refs.paymentForm.validate((valid) => {
        if (valid) {
          this.saveLoading = true

          // 获取当前登录用户ID（后端 payeeId 对应的是登录用户主键 userPkid）
          const payeeId = this.$store.state.loginUser.userPkid || ''

          // 金额用字符串传两位小数，后端再以库中总费用覆盖应收，避免浮点被收成整数
          const toMoneyStr = (val) => (Math.round((parseFloat(val) || 0) * 100) / 100).toFixed(2)
          const receiptInfoList = this.selectedData.map(row => ({
            entrustNum: row.entrustNum || row.id,  // 委托编号
            compName: this.formData.compName,
            usingUnit: this.formData.usingUnit,
            receivableAmount: toMoneyStr(row.totalTestAmount),  // 每条：折后价 + 125%试验费用
            receiptTime: this.formData.receiptTime,
            payeeId: payeeId,
            payeeName: this.formData.payeeName,
            receiptMethod: this.formData.receiptMethod,
            receiptCompany: this.formData.receiptCompany,
            remark: this.formData.remark
          }))

          // 构建完整的保存数据（包含实收款和实收原因）
          const saveData = {
            receiptInfoList: receiptInfoList,
            actualReceiptAmount: toMoneyStr(this.formData.actualReceiptAmount),
            receiptReason: this.formData.receiptReason,
            paymentType: this.formData.paymentType
          }

          // 调用保存接口
          saveReceivables(saveData).then(res => {
            this.saveLoading = false
            if (res.retCode === 'ok') {
              this.$message.success('收款成功')
              this.handleClose()
              // 通知父组件刷新列表
              this.$emit('refresh')
            } else {
              this.$message.error(res.retMsg || '收款失败')
            }
          }).catch(error => {
            this.saveLoading = false
            console.error('保存失败:', error)
            this.$message.error('保存失败')
          })
        } else {
          this.$message.warning('请填写完整信息')
          return false
        }
      })
    },

    /**
     * 关闭弹窗
     * 清除数据并恢复默认状态
     */
    handleClose () {
      this.dialogVisible = false
      // 重置表单
      this.$refs.paymentForm.resetFields()
      // 清空选中数据
      this.selectedData = []
    }
  }
}
</script>

<style scoped>
/* 弹窗底部按钮样式 */
.dialog-footer {
  text-align: right;
}
</style>
